import { AuthActionTypes, initialAuthState } from '../types';
import createAsyncMapReducer from '~lib/shared/redux/reducers/async-map-reducer';
const sendAuthenticationCodeReducer = createAsyncMapReducer(AuthActionTypes.SEND_AUTHENTICATION_CODE, initialAuthState.sendAuthenticationCode);
export default sendAuthenticationCodeReducer;
